import React from 'react';
import {Form} from '../../../../stores/Form/Form';
import cx from 'classnames';
import {observer} from 'mobx-react';
import {listTypes} from '../SelectListModal/enum';
import {HTMLForm} from '../HTMLFormEditor/HTMLForm';
import {Form as SubForm} from '../Form';
import {SubFormList} from '../SubformList';
import {SubFormsList} from '../../types';
import {createDataTestId} from '../../../../utils/dataTestId';
import {FormSectionPlaceholder} from '../FormSectionPlaceholder';
import styles from '../../styles/screen.module.scss';
import {getSubFormFallbackType, getSubFormFallbackId} from '../../utils/getSubFormFallback';

type Props = {
    subForm?: Form;
    isApiLock: () => boolean;
    isFormLocked?: boolean;
    openSelectListModal: (listType: listTypes) => void;
    runSubForm: (id: string, level: number, isHTMLForm: boolean) => Promise<void>;
    subFormsList: SubFormsList;
    parentLevel: number;
    disabledSubformList: boolean;
};

export const SubForms = observer(
    ({
        subForm: currentForm,
        isApiLock,
        openSelectListModal,
        runSubForm,
        subFormsList = [],
        parentLevel,
        disabledSubformList,
        isFormLocked
    }: Props) => {
        const childSubForm = currentForm?.activeSubForm;

        if (subFormsList.length === 0) return null;

        const renderForm = () => {
            const iSHtmlForm = currentForm?.form.Ishtml;
            if (!currentForm)
                return (
                    <FormSectionPlaceholder
                        componentClasses={styles.subformBody}
                        level={parentLevel + 1}
                        isHTML={getSubFormFallbackType(subFormsList) === 'htmlForm'}
                        subFormName={getSubFormFallbackId(subFormsList)}
                        runSubform={runSubForm}
                    />
                );

            return (
                <div className={styles.subformBody}>
                    {iSHtmlForm ? (
                        <HTMLForm
                            isApiLock={isApiLock}
                            readonly={Boolean(currentForm.lockBy) || isFormLocked}
                            form={currentForm}
                            key={`${currentForm.ename}_${currentForm.parentForm.currentRow}`}
                            enterSubform={runSubForm}
                        />
                    ) : (
                        <SubForm
                            currentForm={currentForm}
                            isApiLock={isApiLock}
                            openSelectListModal={openSelectListModal}
                            isSubForm={true}
                            isFormLocked={isFormLocked}
                        />
                    )}
                </div>
            );
        };

        const renderChildForm = () => {
            const disabledChildSubFormList = !!currentForm?.searchModeLevel;

            return (
                <SubForms
                    key={currentForm?.ename}
                    disabledSubformList={disabledChildSubFormList}
                    isApiLock={isApiLock}
                    subForm={
                        childSubForm && !childSubForm.isPanelTypeSubform() ? childSubForm : null
                    }
                    subFormsList={currentForm?.subFormsList}
                    runSubForm={runSubForm}
                    parentLevel={currentForm?.level}
                    openSelectListModal={openSelectListModal}
                />
            );
        };

        return (
            <>
                <div
                    className={cx(styles.subFormWrap)}
                    id={currentForm?.id}
                    {...createDataTestId('sub-form-wrapper', false)}
                >
                    {!!subFormsList.length ? (
                        <SubFormList
                            activeFormId={currentForm?.ename}
                            componentClasses={cx(styles.subFormList)}
                            data={subFormsList}
                            openSubForm={runSubForm}
                            level={parentLevel}
                        />
                    ) : null}
                    {renderForm()}
                </div>
                {renderChildForm()}
            </>
        );
    }
);
